import rewardConfig from './reward';

import approval from '../pages/reward/approval';

describe('reward config encoding', () => {
  it('serializes reward amounts with pound signs and no mojibake', () => {
    const serialized = JSON.stringify(rewardConfig);
    const pound = String.fromCharCode(0x00a3);
    const mojibakePound = String.fromCharCode(0x00c2, 0x00a3);
    const replacementCharacter = String.fromCharCode(0xfffd);

    expect(serialized).toContain(`${pound}50`);
    expect(serialized).toContain(`${pound}500`);
    expect(serialized).not.toContain(mojibakePound);
    expect(serialized).not.toContain(replacementCharacter);
  });
  it('bolds the recipient roles in approval guidance', () => {
    const rewardReason = approval
      .flatMap((page) => ('questions' in page ? page.questions || [] : []))
      .find((question) => question.name === 'approval-reward-reason');

    expect(rewardConfig.approvalCommentHint).toContain('<strong>nominator</strong>');
    expect(rewardReason?.hint).toContain('**nominee**');
  });
});
